import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
 constructor(private http: HttpClient) { }
  
   save( configId: any, payload: any) {
    if (configId) {
      return this.http.patch(urls.API_URL + urls.COMPANY_CONFIGURATION + `/${configId}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.COMPANY_CONFIGURATION, {...payload,})
      .pipe(catchError(errorHandl));

  }

   saveGlobalConfig( configId: any, payload: any) {
    if (configId) {
      return this.http.patch(urls.API_URL + urls.GLOBAL_CONFIGURATION + `/${configId}`, payload)
        .pipe(catchError(errorHandl));
    }
    return this.http.post(urls.API_URL + urls.GLOBAL_CONFIGURATION, {...payload,})
      .pipe(catchError(errorHandl));
  }

   getAllGlobalConfig() {
    return this.http.get(
      `${urls.API_URL}${urls.GLOBAL_CONFIGURATION}`
    ).pipe(catchError(errorHandl));
  }

   getConfigByCompanyWise(companyId: any) {
    return this.http.get(
      `${urls.API_URL}${urls.CONFIG_COMPANY_WISE}/${companyId}`
    ).pipe(catchError(errorHandl));
  }

  // getConfigById(companyId: any) {
  //   return this.http.get(
  //     `${urls.API_URL}${urls.COMPANY_CONFIGURATION}`
  //   ).pipe(catchError(errorHandl));
  // }

    verifyCompany(id: any, payload: any) {
    return this.http.patch(urls.API_URL + urls.COMPANY_CONFIGURATION + `/${id}/manage`, payload)
      .pipe(catchError(errorHandl));
  }

   approvedCompany(id: any, payload: any) {
    return this.http.patch(urls.API_URL + `company-configurations/${id}/approve`, payload)
      .pipe(catchError(errorHandl));
  }

  informationViaEmail(id: any, payload: any) {
    return this.http.post(urls.API_URL + `company-configurations/${id}/missing-fields`, payload)
  }

  
}
